import { dndStitchPredicate, DragDataTypes, type DragData } from '@modules/drag-n-drop/types/drag-data';
import { type Task } from '@modules/tasks/types/task';
import { isStitchItemSummary } from '@sharedlib/dtos/dto/StitchItemSummaryDto';

/**
 * The "Add a new task" trigger converts a dropped entity into a task, so it takes any stitchable
 * except a task: task-on-task is a column reorder, and turning a task into a task would only
 * duplicate it. Labels (tag / knot / connection) are excluded by `dndStitchPredicate` — they carry
 * no title to seed with.
 */
export const newTaskDropPredicate = (dragData: DragData): boolean =>
  dragData.type !== DragDataTypes.task && dndStitchPredicate(dragData.type);

/**
 * Fields to pre-fill the task quick form with when an entity is dropped on "Add a new task".
 *
 * Only the title carries over. It is the one field every stitchable shares, and the only one whose
 * meaning survives the change of type — a note has no priority, and a meeting's time is not a task's
 * due date. Placement comes from the trigger's own column.
 *
 * A multi-item drag seeds from the first entity only; the quick form creates exactly one task.
 */
export function seedFromDroppedEntity(dragData: DragData): Partial<Task> {
  const [source] = dragData.data;

  return isStitchItemSummary(source) ? { title: source.title } : {};
}
